/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTipoCuentaBancaria from 'Infotrack@Modelos/administracion/tipoCuentaBancaria';
import ITipoCuentaBancaria from 'Infotrack@Modelos/administracion/tipoCuentaBancaria/entidades/tipoCuentaBancaria';

export default class ControladorModeloTipoCuentaBancaria {
    private modeloTipoCuentaBancaria: ModeloTipoCuentaBancaria;
    constructor() {
        this.modeloTipoCuentaBancaria = new ModeloTipoCuentaBancaria();
    }

    public consultarTipoCuentaBancaria() {
        return this.modeloTipoCuentaBancaria.consultarTipoCuentaBancaria().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTipoCuentaBancaria(tipoCuentaBancaria: ITipoCuentaBancaria) {
        await this.modeloTipoCuentaBancaria.crearTipoCuentaBancaria(tipoCuentaBancaria);
    }

    public async editarTipoCuentaBancaria(tipoCuentaBancaria: ITipoCuentaBancaria) {
        await this.modeloTipoCuentaBancaria.editarTipoCuentaBancaria(tipoCuentaBancaria);
    }

    public async eliminarTipoCuentaBancaria(tipoCuentaBancaria: ITipoCuentaBancaria) {
        await this.modeloTipoCuentaBancaria.eliminarTipoCuentaBancaria(tipoCuentaBancaria);
    }

    public validarEntidad(tipoCuentaBancaria: ITipoCuentaBancaria): boolean {
        if (tipoCuentaBancaria.CodigoTipoCuentaBancaria === '' || tipoCuentaBancaria.NombreTipoCuentaBancaria === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
